import React from 'react';
import AddScrollHeight from '../../components/AddScrollHeight';
import Barbers from './containers/Barbers';
import PickTime from '../../times/PickTime';

const DynamicBarbers = props => (
  <div>
    <Barbers {...props} />
    <AddScrollHeight>
      <div className="c-second-layer">
        <PickTime {...props} autoHeight from="barber" />
      </div>
    </AddScrollHeight>
  </div>
);

export default DynamicBarbers;



// WEBPACK FOOTER //
// ./src/app/dynamicBooking/services/Barber.jsx